import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a810af51f1bc262422d7547fb32c5a6a6b from "./generated-eb8631ff-7166-4269-9629-fadc1c139e7e.json";

import a135d49527a935049aed80d63c103a887b from "./generated-b2a5f753-d7e0-4701-b238-c982230aff40.json";

import a65f2fffa0fd62b35a53e0ae30d0d4c0fb from "./generated-aa6ca670-2dd1-4f8d-918b-735719646b8a.json";

import a09edf4f9b780f441a9c8e32cff88fd6ab from "./generated-cc566d58-f4a3-4443-b90c-858e66df50e5.json";

import afe2784a21bbe7298be7a850c0808dd75b from "./generated-10a6ac36-8b2a-41ad-9ec6-a6eabc58600d.json";

import a3d98e1f45e4c4cd83b77e156e84f32fdb from "./generated-cdf9235d-4520-4f8b-bbfb-1fbde95b2c4c.json";

import af1442665159ff7160cee5f3b047e6967b from "./generated-63b6b3a2-8de0-4a42-a0a4-48c2bc13d1fe.json";

import a85710685bf92a5ac834b6b8da7f38c52b from "./generated-4aefa9e0-da37-4cb9-918e-597b236ce0df.json";

import a28319a204f3babccabe84dc523275045b from "./generated-fabb313a-ebaf-487c-b27a-1f488ab90315.json";

import addab09c647df5c4ec2d8a217ff93ef6db from "./generated-f8284b5b-4900-4c4a-b914-9a2b7ab0d195.json";

import a8be567d78ff2c7f2fe8d8df7ce4097b2b from "./generated-7aaf6ba1-bdf4-4629-9f80-94d4a33b2e37.json";

import a8b1744c5c2204fe895eb77750ddf78ecb from "./generated-995924e2-5e80-47a8-900f-ee08299dd52c.json";

import a4934e3df9bd7db4418900dd149777e78b from "./generated-4e5da8ea-ab3a-4051-86b3-778335159c02.json";

import a47818ad2022ff6843b0f242e10f7832fb from "./generated-3bd4a024-d398-4007-ad76-05ad3bc8116a.json";

import a7eb56e9943aec74b68542ad3b1a33714b from "./generated-642d9069-e22c-4ef3-8343-501f2a2937d9.json";

import ab0a835e01b6490c8b5636348d40f3cadb from "./generated-65181fc1-768f-417d-a0de-c677b62f99a8.json";

import a2e1bc6a626ad175798f507b6fff33caeb from "./generated-e9494ec6-517c-4f3a-ae1c-96fdb718b82b.json";

import a7d9d7aeb32a704ca6f546bc2eac9d285b from "./generated-8a25fc85-5303-4837-899d-af13fb442efe.json";

import a14c69fdf84bbdecb365801e0c15e34f4b from "./generated-223e7dfd-ad18-4f19-9e0b-2aced4e1e302.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a810af51f1bc262422d7547fb32c5a6a6b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a135d49527a935049aed80d63c103a887b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a65f2fffa0fd62b35a53e0ae30d0d4c0fb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a09edf4f9b780f441a9c8e32cff88fd6ab);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(afe2784a21bbe7298be7a850c0808dd75b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a3d98e1f45e4c4cd83b77e156e84f32fdb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(af1442665159ff7160cee5f3b047e6967b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a85710685bf92a5ac834b6b8da7f38c52b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a28319a204f3babccabe84dc523275045b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(addab09c647df5c4ec2d8a217ff93ef6db);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a8be567d78ff2c7f2fe8d8df7ce4097b2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a8b1744c5c2204fe895eb77750ddf78ecb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a4934e3df9bd7db4418900dd149777e78b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a47818ad2022ff6843b0f242e10f7832fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a7eb56e9943aec74b68542ad3b1a33714b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ab0a835e01b6490c8b5636348d40f3cadb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a2e1bc6a626ad175798f507b6fff33caeb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a7d9d7aeb32a704ca6f546bc2eac9d285b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a14c69fdf84bbdecb365801e0c15e34f4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a2e1bc6a626ad175798f507b6fff33caeb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */